import { AttributesDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const ATTRIBUTE_FRAGMENT: TypedDocumentNode<AttributesDTO> = gql`
  fragment abTestsVariantsAttributesFragment on AbTestsVariantsAttributes {
    label
    type
    value
    workspaceDefaultValue
  }
`
